$(function() {
    "use strict";

    var loadingHandler = {};
    var $link = $();

    $(document).trigger('PhotoUploadOverlay::registerCallback', [
        {
            name: 'insert-topic-cover',
            callbackFunction: function ($target, photos, ideabook, size, isLast) {

                if (isLast) {
                    $(document).trigger('PhotoUploadOverlay::hide');
                }

                $link = $target;
                insertPhoto(photos[0].id, photos[0].src);
            }
        }
    ]);

    var insertPhoto = function(id, src) {
        var $photoInput = $link.closest('form').find('[name*="\[photo_id\]"]');
        if ($photoInput.length > 0) {
            $photoInput.val(id);
        }
        $link.find('img').attr('src', src);
        $link.find('.media__loading').removeClass('media__loading_active');
        if ( $link.hasClass('media_no-media') ) $link.removeClass('media_no-media');
    };

    /*
    var setLoadingHandler = function(link, photoId) {
        var key = Math.random();
        loadingHandler[key] = function(key, link, photoId) {
            return setInterval(function(){
                var size_name = 'topic_cover';
                $.ajax({
                    cache: false,
                    url: $link.data('checkUrl'),
                    type: 'GET',
                    data: { photo_id: photoId, size_name: size_name },
                    success: function(data) {
                        if (typeof(data.url) != 'undefined') {
                            insertToMedia(link, data.url);
                            clearInterval(loadingHandler[key]);
                            loadingHandler[key] = null;
                        }
                    }
                });
            }, 10000);
        }(key, link, photoId);

    };

    var insertLoadingToMedia = function($link) {
        $link.find('.media__loading').addClass('media__loading_active');
        if ( $link.hasClass('media_no-media') ) $link.removeClass('media_no-media');
    };

    var insertToMedia = function($link, imageSrc) {
        $link.find('.media__loading').removeClass('media__loading_active');
        $link.find('img').attr('src', imageSrc).attr('width', $link.outerWidth(true)).attr('height', $link.outerHeight(true));
        if ( $link.hasClass('media_no-media') ) $link.removeClass('media_no-media');
    };
    */

    $('#ForumPostForm').on('submit', function(e){
        if (!$(this).data('submitted')) {
            $(this).data('submitted', true);
        } else {
            e.preventDefault();
        }
    })
});
